import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_fsmqmpbfww: FaireCollectionEntity = {
  token: "pbc_fsmqmpbfww",
  type: "collection",
  name: "Americana",
  heroImageUrl:
    "https://cdn.faire.com/fastly/3b6cfe0d68150f641e9b5b759f1e230bab88a422f80eddebab88af2e6acc7bce.jpeg",
  itemCount: 11,
  brandToken: "b_mmdanrh9jf",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:09:21.705Z",
    importedBy: "entity-db-import-collections",
  },
};
